Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    box = _STYLES$useStyles.box,
    colors = _STYLES$useStyles.colors,
    fontBold = _STYLES$useStyles.fontBold,
    fontSemiBold = _STYLES$useStyles.fontSemiBold;
  var container = Object.assign({}, box, {
    maxWidth: _reactNative.Platform.OS === 'web' ? "calc(".concat(_styles.STYLES.grid.maxBoxWidth, " / 2)") : _styles.STYLES.grid.maxBoxWidth / 2,
    alignItems: 'center',
    position: 'relative',
    flexGrow: 1
  });
  var value = Object.assign({}, fontBold, {
    color: colors.alternative,
    fontSize: _styles.STYLES.fontSize.xl,
    lineHeight: _styles.STYLES.lineHeight.xxl
  });
  var label = Object.assign({}, fontSemiBold, {
    color: colors.brand,
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    textAlign: 'center'
  });
  var image = {
    width: '100%',
    height: '100%'
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    value: value,
    label: label,
    image: image
  });
  return {
    styles: styles
  };
};